<template>
  <div class="footer-box">
    <div class="center-box">
      <!-- <div class="footer-txt">电话：13301563925</div>
      <div class="footer-split">|</div> -->
      <div class="footer-txt">京ICP 备 05067313号-1</div>
      <div class="footer-split">|</div>
      <div class="footer-txt">
        文保网安备案号：1101010023 京卫网审字【2014】第39号
      </div>
      <div class="footer-split">|</div>
      <div class="footer-txt">Copyright 2017 All Rights Reserved.</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
